module.exports = __webpack_public_path__ + "static/media/Sundaram_Mutual_Fund.7fda55db.pdf";